import React from 'react';
import Relay from 'react-relay';

import Button from '../../components/Button';

class VenuePage extends React.Component {
    state = {
        currentFilter: 'ALL',
    }

    componentWillMount() {
      if (this.props.location.pathname === '/venues') {
        this.props.router.push({
            pathname: '/venues/list/all',
            state: {
              filter : 'ALL',
            }
        });
      }
    }

    _onButtonClick() {
        let {that, text} = this.props;
        that.setState({
            currentFilter: text
        });

        let path = '/venues/list/'+text.toLowerCase();
        that.props.router.push({
            pathname : path,
            state :{
                filter : text,
            }
        });
    }

    _renderFilterButton(filterName, index) {
        let color = 'btn-default';

        if (filterName == this.state.currentFilter) {
            color = 'btn-danger';
        }

        return <Button
                    text={filterName}
                    key={index}
                    that={this}
                    color={color}
                    onClick={this._onButtonClick}
                />
    }
    
    render() {
        let filters = ["All"];
        const { selectLevels } = this.state

        return (
        <div className="container">
            <div style={{marginTop:20}}>
                {filters.map((filterName,index) => this._renderFilterButton(filterName,index))}
            </div>
            {this.props.children}
        </div>
        );

    }
}

const styles = {
  total: {
    display: 'inline-block',
    marginLeft: 15,
  },
  searchContainer: {
    display: 'inline-block',
    marginLeft: 15,
    padding: 10,
  },
  input: {
    borderRadius: 20,
    padding: 5,
    minWidth: 250,
  },
  sportSelectContainer: {
    display: 'inline-block',
    marginLeft: 15,
    minWidth: 200,
    height: 26,
  },
}


export default Relay.createContainer(VenuePage, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/pages/Venue/VenuePage.js